import { render } from "./RespondentIdentification.vue?vue&type=template&id=9ef6f3d4"
import script from "./RespondentIdentification.vue?vue&type=script&lang=js"
export * from "./RespondentIdentification.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__